"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stopDisplayEndedRoom = exports.setRooms = exports.setHDEnabled = exports.setClientFocusTo = exports.setActiveRoom = exports.sendMessageToCaller = exports.sendDTMF = exports.scheduleReminder = exports.requestToggleAudioVideo = exports.requestRoomQuit = exports.requestPostRoomLeave = exports.requestPostRoomKicks = exports.requestPostRoomJoin = exports.requestPostRoomInvites = exports.requestPatchRoom = exports.requestHoldRoom = exports.requestGetRooms = exports.requestGetRoom = exports.requestEditRoomInvites = exports.requestDeleteRoom = exports.removeRoom = exports.removeRingingRooms = exports.removeEndedRoom = exports.removeCurrentRoomsByUser = exports.removeCurrentRoomsByClient = exports.rejectIncoming = exports.patchRecording = exports.newOutgoingRoom = exports.ignoreIncoming = exports.forwardRoom = exports.createRoom = exports.clearClientFocus = exports.cancelRemoveEndedRoom = exports.addRooms = exports.addRingingRooms = exports.addEndedRoom = exports.addCurrentRoomsByUser = exports.addCurrentRoomsByClient = exports.acceptIncoming = void 0;
var types = _interopRequireWildcard(require("./types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var acceptIncoming = (_room, audio, video, autoJoin) => ({
  type: types.ROOM_INCOMING_ACCEPT,
  _room,
  audio,
  video,
  autoJoin
});
exports.acceptIncoming = acceptIncoming;
var addCurrentRoomsByClient = _rooms => ({
  type: types.ROOM_CURRENT_CLIENT_ADD,
  _rooms
});
exports.addCurrentRoomsByClient = addCurrentRoomsByClient;
var addCurrentRoomsByUser = _rooms => ({
  type: types.ROOM_CURRENT_USER_ADD,
  _rooms
});
exports.addCurrentRoomsByUser = addCurrentRoomsByUser;
var addEndedRoom = rooms => ({
  type: types.ROOM_ENDED_ADD,
  rooms
});
exports.addEndedRoom = addEndedRoom;
var addRingingRooms = _rooms => ({
  type: types.ROOM_RINGING_ADD,
  _rooms
});
exports.addRingingRooms = addRingingRooms;
var addRooms = _rooms => ({
  type: types.ADD_ROOMS,
  _rooms
});
exports.addRooms = addRooms;
var cancelRemoveEndedRoom = () => ({
  type: types.ROOM_ENDED_CANCEL_REMOVE
});
exports.cancelRemoveEndedRoom = cancelRemoveEndedRoom;
var createRoom = (roomType, name, _sourceFeed, _targets, autoJoin, destNumbers) => ({
  type: types.ROOM_START,
  _sourceFeed,
  _targets,
  name,
  roomType,
  autoJoin,
  destNumbers
});
exports.createRoom = createRoom;
var setClientFocusTo = exports.setClientFocusTo = function setClientFocusTo(_room, _client) {
  var isUserEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: types.SET_CLIENT_FOCUS,
    _room,
    _client,
    isUserEvent
  };
};
var clearClientFocus = exports.clearClientFocus = function clearClientFocus(_room) {
  var isUserEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: types.CLEAR_CLIENT_FOCUS,
    _room,
    isUserEvent
  };
};
var forwardRoom = (_room, _destRoom, destNumber, _destUser) => ({
  type: types.REQUEST_FORWARD_ROOM,
  _room,
  _destRoom,
  destNumber,
  _destUser
});
exports.forwardRoom = forwardRoom;
var ignoreIncoming = _room => ({
  type: types.ROOM_INCOMING_IGNORE,
  _room
});
exports.ignoreIncoming = ignoreIncoming;
var newOutgoingRoom = (_room, audio, video) => ({
  type: types.ROOM_OUTGOING,
  _room,
  video,
  audio
});
exports.newOutgoingRoom = newOutgoingRoom;
var rejectIncoming = exports.rejectIncoming = function rejectIncoming(_room) {
  var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: types.ROOM_INCOMING_REJECT,
    _room,
    silent
  };
};
var removeCurrentRoomsByClient = _rooms => ({
  type: types.ROOM_CURRENT_CLIENT_REMOVE,
  _rooms
});
exports.removeCurrentRoomsByClient = removeCurrentRoomsByClient;
var removeCurrentRoomsByUser = _rooms => ({
  type: types.ROOM_CURRENT_USER_REMOVE,
  _rooms
});
exports.removeCurrentRoomsByUser = removeCurrentRoomsByUser;
var removeEndedRoom = _rooms => ({
  type: types.ROOM_ENDED_REMOVE,
  _rooms
});
exports.removeEndedRoom = removeEndedRoom;
var removeRingingRooms = _rooms => ({
  type: types.ROOM_RINGING_REMOVE,
  _rooms
});
exports.removeRingingRooms = removeRingingRooms;
var removeRoom = _room => ({
  type: types.REMOVE_ROOM,
  _room
});
exports.removeRoom = removeRoom;
var requestDeleteRoom = _room => ({
  type: types.REQUEST_DELETE_ROOM,
  _room
});
exports.requestDeleteRoom = requestDeleteRoom;
var requestEditRoomInvites = (_room, _removedUsers, _addedUsers) => ({
  type: types.REQUEST_EDIT_ROOM_INVITES,
  _room,
  _removedUsers,
  _addedUsers
});
exports.requestEditRoomInvites = requestEditRoomInvites;
var requestGetRoom = _room => ({
  type: types.REQUEST_GET_ROOM,
  _room
});
exports.requestGetRoom = requestGetRoom;
var requestGetRooms = () => ({
  type: types.REQUEST_GET_ROOMS
});
exports.requestGetRooms = requestGetRooms;
var requestHoldRoom = (_room, hold, triggeredBy) => ({
  type: types.REQUEST_ROOM_HOLD,
  _room,
  hold,
  triggeredBy
});
exports.requestHoldRoom = requestHoldRoom;
var requestPatchRoom = (_room, room) => ({
  type: types.REQUEST_PATCH_ROOM,
  _room,
  room
});
exports.requestPatchRoom = requestPatchRoom;
var patchRecording = (_room, recordingState) => ({
  type: types.REQUEST_PATCH_ROOM_RECORDING,
  _room,
  recordingState
});
exports.patchRecording = patchRecording;
var requestPostRoomInvites = (_room, _users) => ({
  type: types.REQUEST_POST_ROOM_INVITES,
  _room,
  _users
});
exports.requestPostRoomInvites = requestPostRoomInvites;
var requestPostRoomJoin = (_room, audio, video) => ({
  type: types.REQUEST_POST_ROOM_JOIN,
  _room,
  audio,
  video
});
exports.requestPostRoomJoin = requestPostRoomJoin;
var requestPostRoomKicks = (_room, _users) => ({
  type: types.REQUEST_POST_ROOM_KICKS,
  _room,
  _users
});
exports.requestPostRoomKicks = requestPostRoomKicks;
var requestPostRoomLeave = (_room, silent) => ({
  type: types.REQUEST_POST_ROOM_LEAVE,
  _room,
  silent
});
exports.requestPostRoomLeave = requestPostRoomLeave;
var requestRoomQuit = _room => ({
  type: types.REQUEST_POST_ROOM_QUIT,
  _room
});
exports.requestRoomQuit = requestRoomQuit;
var requestToggleAudioVideo = (_room, audio, video, screenSharing, triggeredBy) => ({
  type: types.REQUEST_PATCH_ROOM_JOIN,
  _room,
  audio,
  video,
  screenSharing,
  triggeredBy
});
exports.requestToggleAudioVideo = requestToggleAudioVideo;
var scheduleReminder = _room => ({
  type: types.ROOM_INCOMING_SCHEDULE,
  _room
});
exports.scheduleReminder = scheduleReminder;
var sendDTMF = (_room, digit) => ({
  type: types.ROOM_SEND_DTMF,
  _room,
  digit
});
exports.sendDTMF = sendDTMF;
var sendMessageToCaller = (_room, message) => ({
  type: types.ROOM_INCOMING_MESSAGE,
  _room,
  message
});
exports.sendMessageToCaller = sendMessageToCaller;
var setActiveRoom = _room => ({
  type: types.SET_ACTIVE_ROOM,
  _room
});
exports.setActiveRoom = setActiveRoom;
var setHDEnabled = (_room, isHDEnabled) => ({
  type: types.SET_HD_ENABLED,
  _room,
  isHDEnabled
});
exports.setHDEnabled = setHDEnabled;
var setRooms = _rooms => ({
  type: types.SET_ROOMS,
  _rooms
});
exports.setRooms = setRooms;
var stopDisplayEndedRoom = _room => removeEndedRoom([_room]);
exports.stopDisplayEndedRoom = stopDisplayEndedRoom;